import WorkArea from "components/work-area/work-area";
import { useState } from "react";
import { apply } from "../../../../core/utils";
import { displayError, displayMessage } from "../../../../core/utils/modals";
import usePathNavigate from "../../../../hooks/use-path-navigate";
import { cambiarClave as apiCambiarClave } from "../api/configuracion.api";
import CambiarClaveForm, { FormaCambiarClave } from "../components/cambiar-clave.form";

const useCambiarClave = () => {
	const [cargandoDatos, setCargandoDatos] = useState(false);
	const navigate = usePathNavigate();

	const cambiarClave = (forma: FormaCambiarClave) => {
		setCargandoDatos(true);

		apiCambiarClave(forma.claveActual, forma.nuevaClave)
			.then(apply(displayMessage, "La contraseña fue guardada con éxito"))
			.then(apply<string>(navigate, "/:segmento"))
			.catch(displayError)
			.finally(apply(setCargandoDatos, false));
	};

	return {
		cargandoDatos,
		cambiarClave
	};
};

const CambiarClavePage = () => {
	const {
		cargandoDatos,
		cambiarClave
	} = useCambiarClave();

	return (
		<WorkArea title="" path={["Cambio de contraseña"]}>
			<div className="row" style={{ maxWidth: 1382 }}>
				<div className="container">
					<div className="row d-flex justify-content-center">
						<div className="col-12 col-md-8 col-lg-5">
							<div className="card card-login">
								<div className="card-body p-5">
									<CambiarClaveForm loading={cargandoDatos} onAccept={cambiarClave} />
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</WorkArea>
	);
};

export default CambiarClavePage;